const translations = {
  'faqs.seo.title': 'TEFL FAQs - From Teacher Salaries to Entry Requirements',
  'faqs.seo.description': `Read TEFL Iberia's FAQs to find out more about TEFL teaching, from teacher salaries to entry requirements`,
  'faqs.sec1.title': 'Frequently Asked Questions',
  'faqs.sec1.description':
    'Want to learn more? Here are some answers to our most common questions.',

  'faqs.sec1.button1': 'TEFL Courses',
  'faqs.sec1.button2': 'Student Visas',
  'faqs.sec1.button3': 'Accommodation',
  'faqs.sec1.button4': 'Working in Barcelona',
};

export default translations;
